import { isOnboardingComplete, type OnboardingRecord } from "./onboardingComplete";

// Formation mode: while a paid member's documents are being formed and shipped,
// the tracking page is their only room. The lock lifts when documents arrive.

export const LOCKED_STAGES = [
  // Complete but not yet handed off: still their tracking page.
  "pending",
  "ready",
  "ein_acquired",
  // Both spellings of the two state stages are honored so the code keeps working
  // whichever vocabulary a record carries.
  "filings_submitted",
  "filed_with_state",
  "filings_received",
  "state_processed",
  "docs_sent",
] as const;

export function isFormationLocked(
  record: (OnboardingRecord & { fulfillment_stage?: string | null }) | null | undefined,
): boolean {
  if (!record) return false;
  // Onboarding completion, not payment, is what puts a member into formation.
  if (!isOnboardingComplete(record)) return false;
  return LOCKED_STAGES.includes(String(record.fulfillment_stage) as any);
}

// Paths a locked member may still open.
const ALLOWED_PREFIXES = ["/tracking", "/onboarding", "/sign", "/terms", "/privacy", "/j/"];

export function isAllowedWhileLocked(pathname: string): boolean {
  return ALLOWED_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/") || pathname.startsWith(p));
}
